import { render } from "./PedidoMinimo.vue?vue&type=template&id=982c2564&scoped=true"
import script from "./PedidoMinimo.vue?vue&type=script&lang=js"
export * from "./PedidoMinimo.vue?vue&type=script&lang=js"

import "./PedidoMinimo.vue?vue&type=style&index=0&id=982c2564&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-982c2564"]])

export default __exports__